const FALLBACK_INITIAL = 'U';

function normalizeNameForInitials(fullName: string): string {
  if (typeof fullName !== 'string') return '';
  return fullName.replace(/\s*\([^)]*\)/g, '').trim();
}

export function getUserInitials(fullName: string): string {
  const normalized = normalizeNameForInitials(fullName);
  if (!normalized) {
    return FALLBACK_INITIAL;
  }

  const parts = normalized.split(/\s+/).filter(Boolean);

  if (parts.length === 0) {
    return FALLBACK_INITIAL;
  }

  const first = parts[0].charAt(0).toUpperCase();
  if (parts.length === 1) {
    return first;
  }

  const firstSurnameIndex = parts.length >= 4 ? 2 : 1;
  const second = parts[firstSurnameIndex].charAt(0).toUpperCase();
  return `${first}${second}`;
}

export function getNameForAvatarInitials(fullName: string): string {
  const normalized = normalizeNameForInitials(fullName);
  if (!normalized) return '';
  const parts = normalized.split(/\s+/).filter(Boolean);
  if (parts.length <= 2) return normalized;
  if (parts.length >= 4) return `${parts[0]} ${parts[2]}`;
  return `${parts[0]} ${parts[1]}`;
}
